import { Link } from "@tanstack/react-router";
import { cta } from "@/lib/analytics";
import { SectionMark } from "@/components/section-mark";
import photo from "@/assets/sylwia-czerwony-garnitur.webp.asset.json";

export function ProgramSection() {
  return (
    <section id="program" className="content-visibility-auto border-b border-ink/10">
      <div className="container-page grid gap-8 py-12 md:py-16">
        <div>
          <SectionMark number="06" label="Mastermind dla liderów" />
        </div>
        <div className="h-px w-full bg-steel" />
        <div className="grid gap-10 md:grid-cols-[1.1fr_0.9fr] md:items-center md:gap-12">
          <div className="min-w-0">
            <h2 className="display-xl measure-text text-[1.9rem] md:text-[2.4rem]">
              Mastermind dla liderów
            </h2>
            <p className="measure-text mt-6 text-base leading-relaxed text-ink/80 md:text-lg">
              Kameralna, stała grupa właścicieli firm i liderów. Miejsce na trudne decyzje,
              rozmowę o odpowiedzialności i przyjrzenie się temu, co prowadzenie firmy robi z
              Tobą.
            </p>
            <p className="mt-5 text-sm font-medium text-ink">
              Do 10 osób · 9 miesięcy · Warszawa i online
            </p>
            <div className="mt-8">
              <Link
                to="/mastermind"
                {...cta("program-szczegoly", "program", "mastermind")}
                className="btn-base btn-primary inline-flex min-h-11 items-center justify-center"
              >
                Poznaj program Mastermind
              </Link>
            </div>
          </div>
          <figure className="min-w-0">
            <img
              src={photo.url}
              alt="Sylwia Sitkowska"
              width={438}
              height={1804}
              loading="lazy"
              decoding="async"
              className="mx-auto h-[26rem] w-auto object-contain md:h-[34rem]"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
